import { Component, inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CommonService } from "../../services/common.service";

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrl: './contact-form.component.scss'
})
export class ContactFormComponent implements OnInit {
  private _fb: FormBuilder = inject(FormBuilder);
  private _commonService: CommonService = inject(CommonService);

  @Input() giPantMode: boolean = false;
  @Input() henterPantMode: boolean = false;

  form!: FormGroup;
  loading: boolean = false;
  error: boolean = false;
  success: boolean = false;

  constructor() {
    this.formInitialize();
  }

  ngOnInit(): void {
  }

  formInitialize(): void {
    this.form = this._fb.group({
      name: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      message: ['', [Validators.required]],
    });
  }

  onSubmit(): void {
    if (this.loading) return;

    this.success = false;
    this.error = false;
    this.loading = true;

    if (!this.form.valid) return;
    const formValue = this.form.value;

    const requestData = {
      name: formValue.name,
      email: formValue.email,
      message: formValue.message,
      app: this.giPantMode ? "gipant" : "hentpant"
    }

    // TODO request to the API
    this._commonService.contactForm(requestData).subscribe(result => {
      this.loading = false;
      this.success = true;
      this.form.reset();
    }, error => {
      this.loading = false;

      this.error = true;
    });
  }
}

